import type { GetHistoryListRequest, GetHistoryListResponse, AsyncStatusItem, HistoryDetail } from '@/services/history/type/history.type';

export const GetTaskIdDTO = Symbol('GetTaskIdDTO');
export interface GetTaskIdDTO {
    fetch: (type: string) => Promise<string>;
}

export const GetHistoryListDTO = Symbol('GetHistoryListDTO');
export interface GetHistoryListDTO {
    fetch: (data: GetHistoryListRequest) => Promise<GetHistoryListResponse>;
}

export const PutHistoryDTO = Symbol('PutHistoryDTO');
export interface PutHistoryDTO<T> {
    fetch: (data: T) => Promise<void>;
}

export const GetHistoryAsyncStatusListDTO = Symbol('GetHistoryAsyncStatusListDTO');
export interface GetHistoryAsyncStatusListDTO {
    fetch: (taskIdsStr: string[]) => Promise<AsyncStatusItem[]>;
}

export const GetHistoryDetailDTO = Symbol('GetHistoryDetailDTO');
export interface GetHistoryDetailDTO {
    fetch: (taskId: string) => Promise<HistoryDetail>;
}

export const PutHistoryReadDTO = Symbol('PutHistoryReadDTO');
export interface PutHistoryReadDTO {
    fetch: (type: string) => Promise<string>;
}
